import { LoadingOutlined } from "@ant-design/icons";
import { Button, DatePicker, Form, Input, Modal, Spin } from "antd";
import React, { useEffect, useState } from "react";
import moment from "moment";
import EditTaskApi from "../../../api/tasks/EditTaskApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../../helpers/NotificationHelpers";

function EditTaskModal(props) {
  const [form] = Form.useForm();
  const [submit, setSubmit] = useState(false);

  useEffect(() => {
    if (props.visible) {
      form.setFields([
        {
          name: "name",
          value: props.task?.name,
        },
        { name: "targetDate", value: moment(props.task?.taskEndDate) },
      ]);
    }
  }, [props.visible]);

  function handleCancel() {
    form.resetFields();
    props.handleCancel();
  }
  async function onFinish(values) {
    setSubmit(true);
    const apiResponse = await EditTaskApi(
      props.task?.id,
      values.name,
      values.targetDate
    );
    if (apiResponse.error) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      openNotificationSuccess("bottomRight", apiResponse.message);
      props.handleOk();
    } else {
      openNotificationError("bottomRight", `Couldn't delete. Try again later.`);
    }
    handleCancel();
    setSubmit(false);
  }
  return (
    <Modal
      title="Edit Task"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="editTask"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        requiredMark={false}
        form={form}
      >
        <Form.Item
          label="Task*"
          name="name"
          rules={[
            {
              required: true,
              message: "Please enter a Task!",
            },
          ]}
        >
          <Input placeholder="Task name" />
        </Form.Item>
        <Form.Item
          label="Target date*"
          name="targetDate"
          rules={[
            {
              required: true,
              message: "Please enter target date!",
            },
          ]}
        >
          <DatePicker className="w-full" />
        </Form.Item>
        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={() => handleCancel()}>
              Cancel
            </Button>
            <Button
              className="btn w-28"
              type="primary"
              htmlType={submit && "submit"}
              disabled={submit}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                `Save`
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default EditTaskModal;
